// extracted by mini-css-extract-plugin
export var displayDesktop = "TabsAndAccordion-module--displayDesktop--3r3Kb";
export var displayMobile = "TabsAndAccordion-module--displayMobile--2oesC";